import React from "react";
import { useIntl, Link } from "gatsby-plugin-intl";
import { mq, scrollTo } from "../util";
import CloudBubbleImage from "@assets/images/tab-nav/cloud-bubble.png";
import Divider from "@assets/images/tab-nav/divider-square-horizontal.png";
import IconNote from "@assets/images/tab-nav/icon-note.png";
import IconGlory from "@assets/images/tab-nav/icon-glory.png";
import IconDoc from "@assets/images/tab-nav/icon-doc.png";
import IconBook from "@assets/images/tab-nav/icon-book.png";
import IconCharacter from "@assets/images/tab-nav/icon-character.png";
import IconBg from "@assets/svgs/cloud-bg.svg";

const triggerIcons = {
  note: IconNote,
  glory: IconGlory,
  doc: IconDoc,
  book: IconBook,
  character: IconCharacter,
};

const TabNav = ({ items }) => {
  const { locale } = useIntl();

  return (
    <div
      css={mq({
        display: [null, null, "flex"],
        alignItems: "center",
        justifyContent: "center",
        marginTop: [null, 40, 140],
      })}>
      {items.map(({ href, target, icon, text }, index) => (
        <React.Fragment key={text}>
          {index > 0 && (
            <img
              src={Divider}
              alt="Divider"
              width={93}
              height={57}
              css={mq({ display: ["none", null, "inline-block"] })}
            />
          )}
          <TabTrigger key={`tab-nav-item-${index}`} icon={IconNote} target={target} href={href}>
            <div
              css={{
                display: "grid",
                alignItems: "center",
                justifyItems: "center",
              }}>
              <div css={{ gridArea: "1/1" }}>
                <IconBg />
              </div>
              <img css={{ gridArea: "1/1" }} src={triggerIcons[icon]} alt={icon} />
            </div>
            <div
              css={{
                fontSize: locale === "ja" ? 16 : locale === "en" ? 20 : 26,
                letterSpacing: !["en", "ja", "ko"].includes(locale) && "7px",
                whiteSpace: "nowrap",
              }}>
              {text}
            </div>
          </TabTrigger>
        </React.Fragment>
      ))}
    </div>
  );
};

const tabTriggerCSS = mq({
  display: "grid",
  gap: 0,
  gridTemplateColumns: "44px 1fr",
  alignItems: "center",
  padding: "0 30px",
  marginBottom: [null, 20, 0],
  width: 266,
  height: 72,
  background: `url(${CloudBubbleImage}) 50% 50% / cover no-repeat !important`,
  color: "#919191",
  transform: ["scale(0.7)", "none"],
  textAlign: "center",
  "&:hover, &:focus, &:active": {
    color: "#374968",
  },
});

const TabTrigger = ({ target, href, children }) => {
  if (href)
    return (
      <Link to={href} css={tabTriggerCSS}>
        {children}
      </Link>
    );

  return (
    <button type="button" onClick={() => scrollTo(target)} css={tabTriggerCSS}>
      {children}
    </button>
  );
};

export default TabNav;
